import { createContext, useContext, useMemo, useState } from 'react';

/**
 * LanguageProvider.jsx
 *
 * Prepares the architecture for multilingual support without actually
 * implementing translations. The current language code comes from the
 * login response's `system.language` field. A future translation
 * dictionary can plug into `t()` without touching any other layer.
 */

const LanguageContext = createContext(null);

export function LanguageProvider({ initialLanguage = 'en', children }) {
  const [language, setLanguage] = useState(initialLanguage);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      // Placeholder translate function — returns the key itself for now.
      // A real implementation would look `key` up in a dictionary keyed
      // by `language`.
      t: (key) => key,
    }),
    [language]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
}
